import React from 'react';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';

import store from '../../../../../store';
import {
    setSelectedStoreElement,
    showProjectElements,
} from '../../../../../store/actions/Store';

import VirtualTable from '../../../../partials/VirtualTable';

export const columns = [
    { id: 'name', title: 'Name', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: '220px' } },
    { id: 'width', title: 'Width', numeric: true, double: true },
    { id: 'height', title: 'Height', numeric: true, double: true },
    { id: 'depth', title: 'Depth', numeric: true, double: true },
    { id: 'number', title: 'Number', numeric: false,
        style: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', minWidth: '80px' } },
];

const ReportTab = () => {
    const storeData = useSelector((state) => state.store.storeData);

    const elements = storeData ? storeData?.floor_plan_elements || [] : [];

    const filteredElements = elements.filter(element => !element.is_wall); // filter out walls

    const handleRowClick = (row) => {
        store.dispatch(setSelectedStoreElement(row));
    };

    return (
        <Box height="100%">
            {filteredElements && (
                <VirtualTable
                    filter
                    rows={filteredElements}
                    columns={columns}
                    onRowClick={handleRowClick}
                />
            )}
        </Box>
    );
};

export default ReportTab;
